import { PlayerPreferencesPlatformType, } from "../../utils/network/generated/protoTypes";
export var TypeServerPersistenceInfo;
(function (TypeServerPersistenceInfo) {
    TypeServerPersistenceInfo["Received"] = "ServerPersistence > Received";
    TypeServerPersistenceInfo["SetServerPersistence"] = "ServerPersistence > SetServerPersistence";
    TypeServerPersistenceInfo["RemoveServerPersistence"] = "ServerPersistence > RemoveServerPersistence";
})(TypeServerPersistenceInfo || (TypeServerPersistenceInfo = {}));
export var actionServerPersistenceSetInfo = function (serverPersistence, platformType) {
    if (platformType === void 0) { platformType = PlayerPreferencesPlatformType.PLAT_SHARED; }
    return ({
        platformType: platformType,
        serverPersistence: serverPersistence,
        type: TypeServerPersistenceInfo.SetServerPersistence,
    });
};
export var actionServerPersistenceRemove = function (keysToRemove) { return ({
    keysToRemove: keysToRemove,
    type: TypeServerPersistenceInfo.RemoveServerPersistence,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/actionServerPersistence.ts
// module id = 176
// module chunks = 3